"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.ImageContainer = exports.Image = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ImageContainer = _styledComponents.default.div`
  display: flex;
  padding: 30px 20px;

  justify-content: ${props => {
  return props.isEven ? 'flex-end' : 'flex-start';
}};

  @media (min-width: 768px) {
    padding: 60px 20px;
  }
`;
exports.ImageContainer = ImageContainer;
const ImageWrapper = _styledComponents.default.div`
  overflow: hidden;
  position: relative;

  @media (min-width: 768px) {
    max-width: 66%;
  }
`;
exports.ImageWrapper = ImageWrapper;
const Image = _styledComponents.default.img`
  max-width: 100%;
  transform-origin: center center;
`;
exports.Image = Image;
//# sourceMappingURL=styles.js.map